module.exports = __webpack_public_path__ + "static/team-img4-89850fd5122bf3c20389e9d8b5ea9855.jpg";